// Generated by CoffeeScript 2.7.0
var Admin__MembersController;

import OrganizationNavigator from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator.js';

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import OrganizationMembersContainer from 'trunks/vue/admin/components/organizations/users_organizations_container/organization_members.js';

import GenerateUserProfile from 'trunks/controllers/admin/user_profile/generate_profile.js';

export default Admin__MembersController = (function() {
  class Admin__MembersController extends Skylark.App.BaseController {
    index() {
      var organization_container, organization_id;
      organization_id = this.getIds()[0];
      this._generateOrganizationSidebarView(organization_id);
      organization_container = DomMaster.find("#js-organization-container").node;
      return this._generateUserProfile((profileSchema) => {
        return new OrganizationMembersContainer({
          el: organization_container,
          propsData: {
            organization: this.getVars('organization'),
            bindedMembersCount: this.getVars('binded_members_count'),
            membersCount: this.getVars('members_count'),
            organizationApplicationsCount: this.getVars('pending_organization_applications_count'),
            profileSchema: profileSchema,
            fieldable: {
              fields: profileSchema.fields
            }
          }
        });
      });
    }

  };

  Admin__MembersController.include(GenerateMorePopover);

  Admin__MembersController.include(OrganizationNavigator);

  Admin__MembersController.include(GenerateUserProfile);

  return Admin__MembersController;

}).call(this);
